import { useEffect } from 'react';
import { useCookieConsent } from '@/contexts/CookieConsentContext';

export default function AnalyticsScripts() {
  const { consentSettings } = useCookieConsent();

  useEffect(() => {
    if (!consentSettings.analytics) return;

    const trackingId = import.meta.env.VITE_GA_TRACKING_ID?.trim();
    if (trackingId && !document.querySelector('script[data-skore-ga]')) {
      window.dataLayer = window.dataLayer || [];
      window.gtag = (...args: unknown[]) => window.dataLayer?.push(args);
      window.gtag('js', new Date());
      window.gtag('config', trackingId);
      const script = document.createElement('script');
      script.async = true;
      script.dataset.skoreGa = 'true';
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(trackingId)}`;
      document.head.append(script);
    }

    const clarityId = import.meta.env.VITE_CLARITY_ID?.trim();
    if (clarityId && !document.querySelector('script[data-skore-clarity]')) {
      window.clarity = window.clarity || ((...args: unknown[]) => {
        window.clarity!.q = window.clarity!.q || [];
        window.clarity!.q!.push(args);
      });
      const script = document.createElement('script');
      script.async = true;
      script.dataset.skoreClarity = 'true';
      script.src = `https://www.clarity.ms/tag/${encodeURIComponent(clarityId)}`;
      document.head.append(script);
    }
  }, [consentSettings.analytics]);

  return null;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    clarity?: ((...args: unknown[]) => void) & { q?: unknown[] };
  }
}
